import styled from 'styled-components';

export const SpanTextTitle = styled.span`
  color: black;
  font-size: 14px;
`;

export const SpanTextTitleBold = styled.span`
  color: black;
  font-weight: bold;
  font-size: 14px;
`;

export const SpanTextTitleDataBold = styled.span`
  color: #707070;
  font-weight: bold;
  font-size: 13px;
  margin-left: 1%;
`;

export const SpanTextValueTitle = styled.span`
  color: black;
  font-size: 12px;
  margin-left: 3%;
`;

export const SpanTextValue = styled.span`
  color: black;
  font-size: 12px;
  font-weight: 600;
`;

export const TitleH1 = styled.span`
  text-align: center;
  font-size: 54px;
  font-weight: 600;
  position: relative;
`;

export const DescriptionH2 = styled.span`
  text-align: center;
  font-size: 13px;
  font-weight: 600;
`;

export const Dividers = styled.hr`
  border-top: 3px dashed #7c7c7c;
  width: 100%;
  height: 1px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 34%;
  height: 55%;
  /* max-width: 500px; */
  max-height: 400px;
  padding: 15px;
  margin: 0px;
  background-color: #f5f5f5;
  /* position: absolute; */
`;
